export const currentSignalrSideEffect = state => state.app.signalrSideEffects && ({
  periodStatusTrigger: state.app.signalrSideEffects.periodStatusTrigger,
  payload: state.app.signalrSideEffects.payload,
});
